// import CardContainer from '3-components/CardContainer/CardContainer';
import { type FC } from 'react';

interface ListingGroupProps {
    title?: string;
    children: React.ReactNode;
    anchor?: string;
}

const ListingGroup: FC<ListingGroupProps> = ({ title, anchor, children }) => {
    return (
        <div className="listing-group">
            {title && (
                <h2 className="listing-group-title" id={anchor ?? undefined}>{title}</h2>
            )}
            <div className={`listing-group-card-container cols-3`}>
                {children}
            </div>
        </div>
    );
};

export default ListingGroup;
